// @ts-nocheck
import React from 'react';

const MultilineInput = ({ id, label, placeholder, required }) => {
    const textareaId = id ? `textarea-${id}` : 'textarea-preview';

    return (
        <div className="m-2 mr-5 w-full rounded border bg-white p-4 shadow">
            <div className="mb-6">
                <label
                    htmlFor={textareaId}
                    className="mb-2 block text-sm font-medium text-gray-900"
                >
                    {label}
                </label>

                <textarea
                    id={textareaId}
                    className="block max-h-64 min-h-32 w-full rounded border border-gray-300 p-2.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
                    placeholder={placeholder}
                    required={required}
                />
            </div>
        </div>
    );
};

export default MultilineInput;
